import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressViAtlasServiceV2AutocompleteServiceV2Url(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/api/wix-atlas-service-web',
        destPath: '',
      },
      {
        srcPath: '/_api/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
      {
        srcPath: '/_api/wix-atlas-service-web',
        destPath: '',
      },
      {
        srcPath: '/api/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
      {
        srcPath: '/api/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
      {
        srcPath: '/api/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
      {
        srcPath: '/api/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/api/wix-atlas-service-web',
        destPath: '',
      },
    ],
    '*.wixforms.com': [
      {
        srcPath: '/_api/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'platform.rise.ai': [
      {
        srcPath: '/_api/wix-atlas-service-web',
        destPath: '',
      },
      {
        srcPath: '/wix-atlas-service-web',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/api/wix-atlas-service-web',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_atlas_autocomplete';

/** A Predict end-point take an input and returns an list of Prediction object. */
export function predict(payload: object): RequestOptionsFactory<any> {
  function __predict({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'origin.latitude' },
          { path: 'origin.longitude' },
          { path: 'location.latitude' },
          { path: 'location.longitude' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.atlas.v2.prediction',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.vi.atlas.service.v2.AutocompleteServiceV2.Predict',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressViAtlasServiceV2AutocompleteServiceV2Url({
        protoPath: '/v2/predict',
        data: serializedData,
        host,
      }),
      data: serializedData,
    };

    return metadata;
  }

  return __predict;
}
